import { render, staticRenderFns } from "./PageLink.vue?vue&type=template&id=18b3ef62&scoped=true&"
import script from "./PageLink.vue?vue&type=script&lang=js&"
export * from "./PageLink.vue?vue&type=script&lang=js&"
import style0 from "./PageLink.vue?vue&type=style&index=0&id=18b3ef62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b3ef62",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArrowLeftLight: require('/vercel/path0/components/icons/ArrowLeftLight.vue').default})
